import translationsEn from './translationsEn';

function customTranslate(template, replacements) {
  replacements = replacements || {};

  // Translate
  template = translationsEn[template] || template;

  // Replace
  return template.replace(/{([^}]+)}/g, function(_, key) {
    return replacements[key] || '{' + key + '}';
  });
}

customTranslate.currentLanguage = 'en';

export default customTranslate;